import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    name: "",
    logged: false,
    email: "",
    version: "-",
    alert: "",
    message: "",
    userid: "",
    isadmin: false,
    stats: [["Databázové údaje", "Chyba !"]]
  },

  mutations: {
    login(state, user) {
      state.name = user.Name
      state.email = user.Email
      state.logged = true
      state.userid = user.ID
      state.isadmin = user.IsAdmin
    },

    logout(state) {
      state.name = ""
      state.email = ""
      state.logged = false
      state.lang = ""
    },

    alert(state, data) {
      state.alert = data
    },

    message(state, data) {
      state.message = data
    },

    version(state, data) {
      state.version = data
    },

    stats(state, data) {
      state.stats = data
    }
  },

  actions: {
    async fetchme({ commit, state }, axios) {
      if (state.version === "-") {
        commit("version", "=")
        axios.defaults.headers.common["token"] = localStorage.token
        let response = await axios.get("/api/info")
        commit("version", response.data.version)
        commit("stats", response.data.stats)
        if (response.data.user) {
          commit("login", response.data.user)
        }
      }
    }
  }
})
